import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const distID = localStorage.getItem("distributorId");

const tostDismissAll = () => toast.clearWaitingQueue();
const notifySuccess = () =>
  toast.success("Stock Item updated successfully!", {
    position: "bottom-center",
    autoClose: 5000,
    theme: "colored",
  });
const notifyError = () =>
  toast.error("Stock update failed!", {
    position: "bottom-center",
    autoClose: 5000,
    theme: "colored",
  });

const updateStockItemCount = (
  itemId,
  batchName,
  newQuantity,
  successCallback
) => {
  const formData = {
    id: 0,
    distributorId: parseInt(distID),
    productItemId: parseInt(itemId),
    batch: batchName,
    qty: parseFloat(newQuantity),
  };

  axios
    .post(
      "https://erelatevmdev.centralindia.cloudapp.azure.com/api/Inventory/UpdateInventoryForProduct",
      formData,
      {
        headers: {
          "Cache-Control": "no-cache",
          "Access-Control-Allow-Origin": "*",
          Authorization: localStorage.getItem("loginToken"),
        },
      }
    )
    .then((response) => {
      if (response.data.isSuccess) {
        tostDismissAll();
        successCallback();
      }
    })
    .catch((error) => {
      console.error("Error updating stock:", error);
      notifyError();
    });
};

const InventoryTable = ({ data }) => {
  const [quantities, setQuantities] = useState({});
  const [filterText, setFilterText] = useState("");

  const handleMinusStock = (itemId, batchName) => {
    setQuantities((prev) => {
      const batchKey = `${itemId}-${batchName}`;
      const currentQty = prev[batchKey] ?? 0;
      const newQuantity = Math.max(currentQty - 1, 0);

      updateStockItemCount(itemId, batchName, newQuantity, notifySuccess);
      return { ...prev, [batchKey]: newQuantity };
    });
  };

  const handlePlusStock = (itemId, batchName) => {
    setQuantities((prev) => {
      const batchKey = `${itemId}-${batchName}`;
      const newQuantity = (prev[batchKey] ?? 0) + 1;

      updateStockItemCount(itemId, batchName, newQuantity, notifySuccess);
      return { ...prev, [batchKey]: newQuantity };
    });
  };

  const handleQuantityChange = (e, itemId, batchName) => {
    const newQuantity = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and decimals
    setQuantities((prev) => ({
      ...prev,
      [`${itemId}-${batchName}`]: newQuantity,
    }));
  };

  const handleQuantityBlur = (itemId, batchName) => {
    const batchKey = `${itemId}-${batchName}`;
    let newQuantity = parseFloat(quantities[batchKey]);

    if (isNaN(newQuantity) || newQuantity < 0) {
      newQuantity = 0;
    }

    updateStockItemCount(itemId, batchName, newQuantity, notifySuccess);
    setQuantities((prev) => ({ ...prev, [batchKey]: newQuantity }));
  };

  return (
    <div className="card-body">
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>
              <input
                type="text"
                className="form-control"
                placeholder="Search product..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value.toLowerCase())}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.result &&
            data.result.map((product) =>
              product.productLines.map((line) =>
                line.productItems
                  .filter((item) =>
                    item.name.toLowerCase().includes(filterText)
                  )
                  .map((item) => (
                    <React.Fragment key={item.id}>
                      <tr className="table-primary">
                        <td colSpan="6">
                          <strong>{item.name}</strong>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="6">
                          <div className="d-flex flex-wrap gap-3">
                            {item.batchWiseInventory.map((batch) => {
                              const batchKey = `${item.id}-${batch.batchName}`;
                              const quantity =
                                quantities[batchKey] ??
                                batch.currentQuantityInUnits;

                              return (
                                <div
                                  key={batch.batchName}
                                  className="card border-light shadow-sm p-3 rounded-3"
                                  style={{
                                    width: "18rem",
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  <div className="card-body d-flex flex-column">
                                    <h5
                                      className="card-title text-white fw-bold text-center py-2 rounded"
                                      style={{
                                        backgroundColor: "#007bff",
                                        fontSize: "1rem",
                                      }}
                                    >
                                      {batch.batchName}
                                    </h5>

                                    <div className="d-flex justify-content-between align-items-center my-2">
                                      <p className="mb-0">
                                        <strong>Qty:</strong>{" "}
                                        <span className="text-success fw-bold">
                                          {quantity} {item.minInventoryQtyUnit}
                                        </span>
                                      </p>

                                      <span
                                        className={`badge ${
                                          batch.expiringInDays < 10
                                            ? "bg-danger"
                                            : "bg-warning"
                                        } py-2 px-3 rounded-pill`}
                                        style={{
                                          fontSize: "0.9rem",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <i className="far fa-clock me-1"></i>{" "}
                                        {batch.expiringInDays}d
                                      </span>
                                    </div>

                                    <div className="d-flex align-items-center mt-1">
                                      <span
                                        className="badge bg-primary py-2 px-3 rounded-pill"
                                        style={{
                                          fontSize: "0.85rem",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <i className="fa fa-calendar-alt me-1"></i>{" "}
                                        {batch.expiryDateStr}
                                      </span>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center bg-white p-2 rounded shadow-sm mt-2">
                                      <button
                                        className="btn btn-outline-danger btn-sm px-3"
                                        onClick={() =>
                                          handleMinusStock(
                                            item.id,
                                            batch.batchName
                                          )
                                        }
                                      >
                                        <i className="fa fa-minus"></i>
                                      </button>

                                      <input
                                        type="text"
                                        value={quantity}
                                        className="form-control text-center w-50 border-0 fw-bold"
                                        onChange={(e) =>
                                          handleQuantityChange(
                                            e,
                                            item.id,
                                            batch.batchName
                                          )
                                        }
                                        onBlur={() =>
                                          handleQuantityBlur(
                                            item.id,
                                            batch.batchName
                                          )
                                        }
                                      />

                                      <button
                                        className="btn btn-outline-success btn-sm px-3"
                                        onClick={() =>
                                          handlePlusStock(
                                            item.id,
                                            batch.batchName
                                          )
                                        }
                                      >
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
              )
            )}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryTable;
